import type { NodoDoc } from "@/componentes/documentos/Documento"

/** Lo que devuelve la API de documentos y plantillas de Talento Humano. */

export type TipoCampo =
  | "texto"
  | "parrafo"
  | "fecha"
  | "hora"
  | "numero"
  | "monto"
  | "si_no"
  | "lista"

export type CampoPlantilla = {
  clave: string
  etiqueta: string
  tipo: TipoCampo
  obligatorio: boolean
  opciones?: string[] | null
  ayuda?: string | null
}

export type CategoriaPlantilla =
  | "SOLICITUD"
  | "CONSTANCIA"
  | "CONTRATO"
  | "ACUERDO"
  | "ASIGNACION"
  | "DISCIPLINARIO"
  | "DECLARACION"
  | "OTRO"

export type UsoPlantilla = "EMPLEADO" | "TALENTO_HUMANO"

export type PlantillaTH = {
  id: number
  codigo: string
  nombre: string
  descripcion: string | null
  categoria: CategoriaPlantilla
  uso: UsoPlantilla
  cuerpo: NodoDoc
  campos: CampoPlantilla[]
  requiere_aprobacion: boolean
  version: number
  activa: boolean
}

export type EstadoDocumento = "SOLICITADO" | "APROBADO" | "RECHAZADO" | "EMITIDO" | "ANULADO"

export type DocumentoTHResumen = {
  id: number
  codigo: string
  titulo: string
  plantilla_id: number
  persona_id: number
  persona: string | null
  estado: EstadoDocumento
  creado_en: string
  resuelto_en: string | null
  observacion: string | null
  tiene_firmado: boolean
}

export type DocumentoTH = DocumentoTHResumen & {
  plantilla_version: number
  datos: { ficha?: Record<string, unknown>; campos?: Record<string, unknown> }
  cuerpo: NodoDoc
  firmado_en: string | null
}

export type VistaPrevia = { cuerpo: NodoDoc; faltantes: string[] }

export const CATEGORIAS: { valor: CategoriaPlantilla; etiqueta: string }[] = [
  { valor: "SOLICITUD", etiqueta: "Solicitudes" },
  { valor: "CONSTANCIA", etiqueta: "Constancias" },
  { valor: "CONTRATO", etiqueta: "Contratos" },
  { valor: "ACUERDO", etiqueta: "Acuerdos" },
  { valor: "ASIGNACION", etiqueta: "Asignaciones y entregas" },
  { valor: "DISCIPLINARIO", etiqueta: "Disciplinarios" },
  { valor: "DECLARACION", etiqueta: "Declaraciones" },
  { valor: "OTRO", etiqueta: "Otros" },
]

export const ESTADOS: Record<
  EstadoDocumento,
  { etiqueta: string; tono: "neutro" | "aviso" | "exito" | "peligro" | "info" }
> = {
  SOLICITADO: { etiqueta: "Pendiente", tono: "aviso" },
  APROBADO: { etiqueta: "Aprobado", tono: "exito" },
  RECHAZADO: { etiqueta: "Rechazado", tono: "peligro" },
  EMITIDO: { etiqueta: "Emitido", tono: "info" },
  ANULADO: { etiqueta: "Anulado", tono: "neutro" },
}

export const TIPOS_CAMPO: { valor: TipoCampo; etiqueta: string }[] = [
  { valor: "texto", etiqueta: "Texto corto" },
  { valor: "parrafo", etiqueta: "Párrafo" },
  { valor: "fecha", etiqueta: "Fecha" },
  { valor: "hora", etiqueta: "Hora" },
  { valor: "numero", etiqueta: "Número" },
  { valor: "monto", etiqueta: "Monto" },
  { valor: "si_no", etiqueta: "Sí / No" },
  { valor: "lista", etiqueta: "Lista de opciones" },
]
